export default {
  short_description: 'Oszczędzaj czas i zdobywaj nagrody!',
  full_description:
    'Aplikacja {{name}} już tu jest – dla jeszcze łatwiejszego zamawiania:\n\n• Błyskawiczne zamawianie przez aplikację\n\n• Natychmiastowe powiadomienia o promocjach i nagrodach\n\n• Łatwe zbieranie i wymiana punktów\n\n• Śledź status zamówienia w czasie rzeczywistym\n\nZ przyjemnością oferujemy naszą aplikację – mamy nadzieję, że sprawi Ci tyle radości, co nam!`',
};
